export const PRODUCTION_STAGES = [
  {
    id: "forming",
    label: "Forming",
    durationDays: 1,               // default UI assist only
    dependsOn: null,
  },
  {
    id: "drying",
    label: "Drying",
    durationDays: 2,
    dependsOn: "forming",
  },
  {
    id: "bisque",
    label: "Bisque Firing",
    durationDays: 1,
    dependsOn: "drying",
  },
  {
    id: "glazing",
    label: "Glazing",
    durationDays: 1,
    dependsOn: "bisque",
  },
  {
    id: "glazeFiring",
    label: "Glaze Firing",
    durationDays: 1,
    dependsOn: "glazing",
  },
  {
    id: "qc",
    label: "QC & Pack",
    durationDays: 1,
    dependsOn: "glazeFiring",
  },
  {
    id: "dispatch",
    label: "Dispatch",
    durationDays: 0,
    dependsOn: "qc",
  }
];
